export enum BarColors {
  white = 'var(--brand-white)',
  red300 = 'var(--brand-red-300)',
  cream300 = 'var(--brand-cream-300)',
  green300 = 'var(--brand-green-300)',
  neutralsWarmGrey200 = 'var(--brand-neutrals-warm-grey-200)',
  neutralsWarmGrey400 = 'var(--brand-neutrals-warm-grey-400)',
}

export enum BorderColors {
  borderForWhite = '#cccccc',
  borderForRed300 = 'var(--brand-red-500)',
  borderForCream300 = 'var(--brand-cream-500)',
  borderForGreen300 = 'var(--brand-green-500)',
  borderForNeutralsWarmGrey200 = '#adbac1',
  borderForNeutralsWarmGrey400 = '#849395',
}

export enum TextColors {
  black = 'var(--brand-black)',
  brandPrimary = 'var(--brand-primary)',
}

export enum BorderStyles {
  solid = 'solid',
  dashed = 'dashed',
}
